<div class="td-header">
  <h2 class="td-title">{{ 'TENANT_LAYOUT.CHOOSE_TENANT' | transloco }}</h2>
  <mat-icon class="icon-md cursor-pointer" svgIcon="close" (click)="cancel()"></mat-icon>
</div>

<div class="td-search">
  <mat-icon class="icon-sm td-search-icon" svgIcon="search"></mat-icon>
  <input type="text" [(ngModel)]="searchValue" (ngModelChange)="onSearch($event)" placeholder="Search tenants..." />
</div>

<div class="td-filters">
  <button *ngFor="let filter of filters" class="td-chip" [class.active]="activeFilter === filter.key" (click)="setFilter(filter.key)">
    {{ filter.label | transloco }}
  </button>
</div>
<div class="td-divider"></div>
<div class="td-list">
 <div *ngFor="let tenant of filteredTenants" class="td-card" [class.selected]="pendingId === tenant.tenantId" [title]="tenant.tenantId" (click)="select(tenant)" (dblclick)="select(tenant); confirm()">
    <div class="td-avatar">
      {{ initials(tenant) }}
    </div>
    <div class="td-info">
      <div class="td-name">{{ tenant.tenantId }}</div>
      <div class="td-sub">{{ subtitle(tenant) }}</div>
    </div>
     <img *ngIf="pendingId === tenant.tenantId" class="td-check" src="assets/icons/check_Icon.svg" alt="selected" />
 </div>
  <div *ngIf="filteredTenants.length === 0" class="td-empty">
    <img src="assets/images/no_result.svg" alt="No Results" />
    <div class="no-results-text">{{'COMMON_MESSAGE.NO_RESULTS_FOUND' | transloco }}</div>
  </div>
</div>
<div class="td-actions">
  <button class="td-btn td-btn-cancel" (click)="cancel()">{{'BUTTONS.CANCEL' | transloco}}</button>
  <button class="td-btn td-btn-confirm" [disabled]="!changed" (click)="confirm()">{{'BUTTONS.CONFIRM' | transloco}}</button>
</div>